import { Component, Input } from '@angular/core';
import { getStyles } from './../styles';
import { ReportShareComponent } from '../report-share.component';

@Component({
  selector: 'app-secondary-style',
  templateUrl: './secondary-style.component.html'
})
export class SecondaryStyleComponent  extends ReportShareComponent {

  get html(): string {
    return this.report?.secondaryCoachingStyleDesc?.replaceAll("\n","<br />") ?? '';
  }

  get secondaryStrength(): string {
    if (this.isFacilitatorTemplate) {
      return "OVERVIEW OF YOUR FACILITATOR STRENGTHS";
    } else if (this.isDirectReport) {
      return "OVERVIEW OF DIRECT REPORT PREFERRED STRENGTHS";
    } else if (this.isPeerToPeer) {
      return "OVERVIEW OF PEER PREFERRED STRENGTHS";
    } else if (this.isCoacheePreference) {
      return "OVERVIEW OF COACHEE PREFERRED STRENGTHS";
    }
    return "OVERVIEW OF YOUR COACHING STRENGTHS";
  }
}